import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=ff7b811c&"
import script from "./tags.component.ts?vue&type=script&lang=ts&"
export * from "./tags.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports